
function Accordion($el) {
    this.$el = $el || null;

    this.isExperienceEditor = $('.is-experience-editor').length;

    if (this.$el.length) {
        this.setupDefaults();

        if (!this.isExperienceEditor) {
            this.addListeners();
            
        } else {
            this.initExpEd();
        }
    }
};

Accordion.prototype.setupDefaults = function () {
    this.dom = {
        $trigger: this.$el.find('.js-accordion-trigger'),
        $icon: this.$el.find('.js-accordion-trigger').find('.fa'),
        $content: this.$el.find('.js-accordion-content')
    }
};

Accordion.prototype.addListeners = function () {
    this.dom.$trigger.on('click touchstart keypress', this.onTriggerClick.bind(this));
};

Accordion.prototype.onTriggerClick = function (e) {
    e.stopPropagation();
    e.preventDefault();

    this.$el.toggleClass('active');
    this.toggleContent();
};

Accordion.prototype.initExpEd = function () {
    this.$el.toggleClass('active');
    this.dom.$content.slideDown();
};

Accordion.prototype.toggleContent = function () {
    if(!this.$el.hasClass('active')) {
        this.dom.$icon.attr('class', 'fa fa-plus');
        this.dom.$content.stop(true, true).slideUp(250, 'easeInOutExpo');
    } else {
        this.dom.$icon.attr('class', 'fa fa-minus');
        this.dom.$content.stop(true, true).slideDown(250, 'easeInOutExpo');
    }

    setTimeout(function() {
        $(window).resize();
    }, 250);
};

(function ($) {
    $('.available-programs__program, .pl-faqs__faq').each(function (index, element){
        var el = new Accordion($(element));
        el.toggleContent();
    });
})(jQuery);